import axios from 'axios';
import { defineStore } from 'pinia';

const TOKEN = 'token';
const OMS = 'oms';
const BDAY = 'bday';

const updateHeaders = (isAuthenticated, token) => {
	axios.defaults.headers.common['Authorization'] = isAuthenticated ? ('Token ' + token) : '';
}

export const useUserStore = defineStore('user', {
	state: () => {
		let isAuthenticated = false;
		let token = '';
		let oms = '';
		let bday = '';
		if (localStorage.getItem(TOKEN)) {
			isAuthenticated = true;
			token = localStorage.getItem(TOKEN);
			oms = localStorage.getItem(OMS);
			bday = localStorage.getItem(BDAY);
		}
		updateHeaders(isAuthenticated, token);
		return {
			isAuthenticated,
			token,
			oms,
			bday,
		};
	},
	getters: {
		// doubleCount: (state) => state.count * 2,
	},
	actions: {
		login(oms, bday, token) {
			this.isAuthenticated = true;
			this.token = token;
			this.oms = oms;
			this.bday = bday;
			localStorage.setItem(OMS, oms);
			localStorage.setItem(BDAY, bday);
			localStorage.setItem(TOKEN, token);
			updateHeaders(this.isAuthenticated, this.token);
		},
		logout() {
			this.isAuthenticated = false;
			this.token = '';
			this.oms = '';
			this.bday = '';
			localStorage.removeItem(OMS);
			localStorage.removeItem(BDAY);
			localStorage.removeItem(TOKEN);
			updateHeaders(this.isAuthenticated, this.token);
		},
	},
});
